var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edit-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg edit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.32,6.16A1.43,1.43,0,0,0,3,7.2V27.63a2.42,2.42,0,0,0,.35,1.05A1.29,1.29,0,0,0,4.37,29H24.8a2.34,2.34,0,0,0,1-.35,1.29,1.29,0,0,0,.35-1.05V19.78a1.4,1.4,0,1,1,2.8,0v7.85a5.08,5.08,0,0,1-1.22,3.15A4.25,4.25,0,0,1,24.62,32H4.37a5,5,0,0,1-3.15-1.22A4.23,4.23,0,0,1,0,27.63V7.2A4.4,4.4,0,0,1,1.22,4.06,4.73,4.73,0,0,1,4.37,2.84h7.68a1.4,1.4,0,1,1,0,2.79H4.37A1.65,1.65,0,0,0,3.32,6.16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75.39a1.6,1.6,0,0,1,2.09,0l5.77,5.77a1.6,1.6,0,0,1,0,2.09L17.11,22.74a1.28,1.28,0,0,1-1,.35H10.3A1.37,1.37,0,0,1,8.91,21.7V15.93a2.42,2.42,0,0,1,.35-1Zm-12,16.07V20.3h3.84L28.64,7.2,24.8,3.36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.669eafa33bcb085bdcb07cfd2e871f20.svg";
export { ForwardRef as ReactComponent };